import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, requireAdmin = false, requireCommercial = false }) {
  const { user, loading, isAuthenticated, isAdmin, isCommercial } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        Chargement...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location, authRequired: true }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace state={{ from: location, adminRequired: true }} />;
  }

  if (requireCommercial && !isCommercial && !isAdmin) {
    return <Navigate to="/" replace state={{ from: location, commercialRequired: true }} />;
  }

  return children || null;
}

export default ProtectedRoute;
